import { Injectable, inject } from '@angular/core';
import { MrtAmplitudeEventKeys, MrtAmplitudeService } from '@shared/services/shared/amplitude/mrt-amplitude.service';

@Injectable({ providedIn: 'root' })
export class OldUiAmplitudeService {
  private readonly amplitude = inject(MrtAmplitudeService);

  // Wait for a max. of 1s, in case the Amplitude client call fails
  public async trackOldUIVisit(): Promise<void> {
    await Promise.race([
      this.amplitude.track(MrtAmplitudeEventKeys.NAVIGATE_TO_VAADIN)?.promise,
      new Promise(resolve => setTimeout(resolve, 1000)),
    ]);
  }
}
